export default __webpack_public_path__ + "static/media/event-sad-face.237b1fc8.svg";